import http from './../../../core/services/http.service';
import {AppSettings} from "@/shared/AppSettings";
import i18n from "../../../shared/i18n";
import EventBus from "../../event-bus";
import {LOCALES_LOADED} from "../../event-bus/event-bus-names";
import HelperService from "../../../core/services/helper.service";
import {uuid} from "vue-uuid";
import _ from 'lodash'
import MenuService from "@/core/components/menu/MenuService";
import {store} from "../index";
import {Formatter, SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";
import ProfileService from "@/modules/auth/Profile/ProfileService";
import ArtisioIdleTracker from "@/core/services/idleTracker.service";
import moment from "moment";
import ItemLocationService from "@/modules/setup/branch/ItemLocationService";
import {IMPORTANT_INFO_DISMISSED, RELEASE_NOTE_DISMISSED} from "@/modules/constants";
import ReleaseNotesService from "@/modules/common/ReleaseNotesService";
import i18nService from "@/core/services/i18n.service";
import ContractService from "@/modules/contracts/ContractService";
import {hasPermission} from "@/core/directives/permission";

function getDefaultNotifications() {
  return [{
    key: 'overdue_invoices',
    display_name: i18n.t('Overdue Invoices'),
    count: 0,
    icon: 'file-invoice',
    iconClass: 'text-danger',
    urlName: null,
  }];
}

let getDefaultGeneralContractModal = () => {
  return {
    show: false,
    object: null,
    pdf_url: null,
    status: null,
    signature: null,
    staff_signature: null,
    loading: false,
    source: null,
    fileType: null,
    objectName: null,
    enableESignature: null,
    refreshOnSubmit: false,
    modalTitle: false,
    contract_data: null,
  }
}

export default {
  namespaced: true,
  state: {
    menu: {
      collapsed: HelperService.isMobileDevice()
    },
    notifications: getDefaultNotifications(),
    progresses: [],
    currentUser: null,
    permissionGroups: null,
    permissionRoles: null,
    currentBranch: null,
    itemLocations: [],
    defaultItemLocation: null,
    loaded: false,
    formats: {
      precisionCount: 2,
    },
    defaultPaymentTerms: 30,
    defaultSettlementDays: 30,
    defaultCreditLimit: null,
    countries: [],
    countriesMap: {},
    taxStatuses: [],
    cataloguingLifecycleOptions: [],
    photographyLifecycleOptions: [],
    incrementCalculationSource: [
      {key: 'Bid', value: 'bid'},
      {key: 'Reserve', value: 'reserve'}
    ],
    currencies: [],
    locales: {},
    hasMoreThanOneLanguage: false,
    imageFileFormats: ['image/jpeg', 'image/jpg', 'image/png'],
    videoFileFormats: ['video/mp4'],
    audioFileTypes: ['audio/mpeg'],
    contractFileTypes: ['application/pdf'],
    customerMaxContractCount: 100, // Number of files
    customerMaxContractSizeSum: 10, // Size in megabytes
    contractMaxFileSize: 10, // Size in megabytes
    attachmentFileTypes: ['application/pdf'],
    customerMaxAttachmentCount: 100, // Number of files
    customerMaxAttachmentSizeSum: 10, // Size in megabytes
    inventoryMaxAttachmentCount: 100, // Number of files
    inventoryMaxAttachmentSizeSum: 10, // Size in megabytes
    conditionReportImagesMaxAttachmentCount: 200, // Total number of files
    conditionReportImagesAttachmentSizeSum: 500, // Size in megabytes
    imageMaxFileSize: 10, // Size in megabytes
    audioMaxFileSize: 10, // Size in megabytes
    attachmentMaxFileSize: 10, // Size in megabytes
    identityVerificationAttachmentTypes: [
      'image/jpeg',
      'image/png',
      'image/bmp',
      'image/webp',
      'application/pdf'
    ],
    identityVerificationMaxFileSize: 2, // Size in megabytes
    identityVerificationMaxFileCount: 10, // Number of files
    videoMaxFileSize: 20, // Size in megabytes
    imagesZipMaxFileSize: 5000, // Size in megabytes
    bulkImagesMaxSize: 5000, // Size in megabytes
    maxImageCountPerLot: 20, // Size in megabytes
    imagesZipMaxFileCount: 100000,
    bulkImagesMaxFileCount: 100000,
    enableInventoryQuantity: false,
    enableSyncWebsiteFromArtisio: false,
    enableAccountingExport: false,
    isDynamicFieldsTemplateFromCategory: false,
    isAccountingEnabled: null,
    isManualAccountingSyncDisabled: null,
    accountingProvider: null,
    hasArtisioTimedProvider: null,
    generalRulesAndRestrictions: {
      start_price_lower_than_reserve: false
    },
    settlementLabels: {},
    miscellaneousItemCharges: [
      {key: i18n.t("Other"), value: "other"}
    ],
    invoiceMiscellaneousItemCharges: [
      {key: i18n.t("Other"), value: "other"}
    ],
    predefinedVendorChargeNames: [
      {key: i18n.t("Other"), value: "other"}
    ],
    maxUsesCount: 15,
    defaultAuctionType: "timed",
    defaultBidderStatus: "pending",
    paymentMethods: [
      {key: i18n.t("Cash"), value: "cash"},
      {key: i18n.t("Cheque"), value: "cheque"},
      {key: i18n.t("Debit Card"), value: "debit_card"},
      {key: i18n.t("Deposit"), value: "deposit"},
      {key: i18n.t("Bank Transfer"), value: "bank_transfer"},
      {key: i18n.t("BACS"), value: "bacs"}
    ],
    paymentMethodsMap: {},
    paymentAccountingCodeOptions: [],
    receiptContainerOptions: [],
    clientTierOptions: [],
    lotStatuses: [
      {key: i18n.t('Active'), value: 'active'},
      {key: i18n.t('Sold'), value: 'sold'},
      {key: i18n.t('Unsold'), value: 'unsold'},
      {key: i18n.t('Expired'), value: 'expired'},
      {key: i18n.t('Withdrawn'), value: 'withdrawn'},
      {key: i18n.t('Draft'), value: 'draft'},
    ],
    reservationStatuses: [
      {key: i18n.t('Reserved'), value: 'reserved'},
      {key: i18n.t('Lotted'), value: 'lotted'},
      {key: i18n.t('Sold'), value: 'sold'},
      {key: i18n.t('Unsold'), value: 'unsold'},
      {key: i18n.t('Withdrawn'), value: 'withdrawn'},
    ],
    vendorChargeLotStatuses: [
      {key: i18n.t('Lotted'), value: 'lotted'},
      {key: i18n.t('Sold'), value: 'sold'},
      {key: i18n.t('Unsold'), value: 'unsold'},
      {key: i18n.t('Withdrawn'), value: 'withdrawn'},
    ],
    // twoFactorAuthTypes: [
    //   // {key: 'Mobile (SMS)', value: 'mobile'},
    //   {key: 'Email', value: 'email'},
    // ],
    dateFormats: [
      {key: 'DD/MM/YYYY', value: 'DD/MM/YYYY'},
      {key: 'YYYY-MM-DD', value: 'YYYY-MM-DD'},
      {key: 'DD-MM-YYYY', value: 'DD-MM-YYYY'},
      {key: 'MM-DD-YYYY', value: 'MM-DD-YYYY'},
      {key: 'MMMM D, YYYY', value: 'MMMM D, YYYY'},
      {key: 'ddd D MMM YYYY', value: 'ddd D MMM YYYY'},
    ],
    timeFormats: [
      {key: 'HH:mm (20:00)', value: 'HH:mm'},
      {key: 'HH:mm:ss (20:00:12)', value: 'HH:mm:ss'},
      {key: 'hh:mm A (08:00 PM)', value: 'hh:mm A'},
    ],
    customerStatuses: [
      {key: i18n.t('Active'), value: 'active'},
      {key: i18n.t('Pending'), value: 'pending'},
      {key: i18n.t('Blocked'), value: 'blocked'},
    ],
    customerLeadStatuses: [
      {key: i18n.t('Unqualified'), value: 'unqualified'},
      {key: i18n.t('Qualified'), value: 'qualified'},
      {key: i18n.t('Converted'), value: 'converted'},
    ],
    customerGenders: [
      {key: i18n.t('Male'), value: 'male'},
      {key: i18n.t('Female'), value: 'female'},
      {key: i18n.t('Other'), value: 'other'},
    ],
    customerAcquisitionSources: [
      {key: i18n.t('Google'), value: 'Google'},
      {key: i18n.t('Other Search Engine'), value: 'Other Search Engine'},
      {key: i18n.t('Social Media'), value: 'Social Media'},
      {key: i18n.t('Magazine Advert'), value: 'Magazine Advert'},
      {key: i18n.t('Public Banner'), value: 'Public Banner'},
      {key: i18n.t('Friend Referral'), value: 'Friend Referral'},
      {key: i18n.t('Other (free text)'), value: 'Other (free text)'},
      {key: i18n.t('Radio Advert'), value: 'Radio Advert'},
      {key: i18n.t('Facebook'), value: 'Facebook'},
      {key: i18n.t('Instagram'), value: 'Instagram'},
      {key: i18n.t('Trade Show'), value: 'Trade Show'},
      {key: i18n.t('Twitter'), value: 'Twitter'},
      {key: i18n.t('WeChat'), value: 'WeChat'},
      {key: i18n.t('YouTube'), value: 'YouTube'},
    ],
    negotiationStatuses: [
      {key: i18n.t('Reserve met'), value: 'reserve_met'},
      {key: i18n.t('Reserve not met'), value: 'reserve_not_met'},
      {key: i18n.t('Negotiation started'), value: 'negotiation_started'},
      {key: i18n.t('Negotiation completed'), value: 'negotiation_completed'},
    ],
    collectionInfoEnabled: true,
    auctionSettingsDefaultValues: {
      has_delay: true,
      bidding_extension: {key: "2 minutes", value: 120},
      lot_delay_batch_size: 1,
      lot_delay_seconds: {key: "20 seconds", value: 20},
    },
    bidderStatusOptions: [
      {key: i18n.t('Approved'), value: 'approved'},
      {key: i18n.t('Rejected'), value: 'rejected'},
      {key: i18n.t('Pending'), value: 'pending'},
      {key: i18n.t('Awaiting Deposit'), value: 'awaiting_deposit'},
    ],
    identityVerificationTypes: [
      {key: i18n.t('Verified'), value: 'verified'},
      {key: i18n.t('Pending'), value: 'pending'},
      {key: i18n.t('Unverified'), value: 'unverified'},
    ],
    kycVerificationTypes: [
      {key: i18n.t('Verified'), value: 'verified'},
      {key: i18n.t('Pending'), value: 'pending'},
      {key: i18n.t('Unverified'), value: 'unverified'},
    ],
    creditLimitTypes: [
      {key: 'Auction', value: 'auction'},
      {key: 'Lot', value: 'lot'},
    ],
    template_types: [],
    notificationActivityTypes: [],
    isCarAuctionHouse: false,
    liveAuctionProvider: false,
    maxTotalDelayOptions: [],
    warning: null,
    enableContinuousAuction: false,
    excludeSideBarColumns: [],
    invoiceComplaintStatuses: [
      {key: i18n.t('Pending'), value: 'pending'},
      {key: i18n.t('Resolved'), value: 'resolved'},
    ],
    availableFilterFields: [],
    toggleColumns: {
      modal: {
        show: false,
        data: [],
        uuid: null,
        loading: false,
      },
    },
    uniqueDynamicFields: [],
    googleMapToken: '',
    dateRangeModal: {
      show: false
    },
    isGoogleApiSetUp: false,
    departmentThumbnailSettings: {
      max_size: 1,
      max_width: 512,
      max_height: 512,
      formats: ['image/jpeg', 'image/jpg', 'image/png']
    },
    dynamicFieldsFilters: [],
    identificationFieldsFilters: [],
    timeDiff: null,
    addressTypeToShowInCustomerEditForm: '',
    idleTracker: null,
    idleTimeoutMilliseconds: 1000 * 60 * 30, // 30 minutes in milliseconds
    loginAlertMsg: null,
    oldLotPrintoutsEnabled: false,
    postCodeSearchProvider: null,
    postCodeProviderInfo: {},
    continuousAuctionLotFormDefaultDatesConfiguration: {},
    data_collection_provider_info: {
      has_data_collection_provider: false
    },
    hasStripeProvider: true,
    customerDefaultEmailDomain: "",
    isSalesTaxEnabled: false,
    branchBasedItemLocation: true,
    enableGroupedItems: false,
    autoPopulateAuctionInReservation: false,
    enableInventoryDraft: false,
    customerIdentificationTypes: [
      {key: i18n.t('Passport'), value: 'passport'},
      {key: i18n.t('ID Card'), value: 'id_card'},
      {key: i18n.t('Driver\'s License'), value: 'drivers_license'},
      {key: i18n.t('Proof of Address'), value: 'proof_of_address'},
      {key: i18n.t('Other'), value: 'other'},
    ],
    enableSepa: false,
    disableItemEditOnSold: false,
    lotAmountsCalculationsLogic: null,
    customerTypes: [],
    intermediaryCustomerTypes: [],
    intermediaryAgreementTypes: [],
    defaultMiscellaneousItemCharges: [],
    inventoryLotAutoSelectEnable: false,
    inclusiveTiersEnabled: false,
    enableSettlementCancellation: true,
    enableDebitNoteCreation: false,
    enableInvoiceCancellation: true,
    enableReceiptStatus: false,
    receiptStatuses: [],
    inclusiveTaxForFinancialObjects: [],
    assignLatestPaddleNumber: false,
    enableTimedSessions: false,
    reserveTypes: [],
    enableNlRelations: false,
    customerRelationTypes: [],
    socketLastInteractionTime: new Date().getTime(),
    isSocketConnected: false,
    importantNotificationInfo: null,
    uiLanguages: ['en'],
    importantNotificationModal: {
      show: false
    },
    paymentBankAccounts: [],
    releaseNoteInfo: null,
    releaseNoteModal: {
      show: false,
      releaseNote: null,
      doNotShowAgainVisible: false
    },
    releaseNotesListModal: {
      show: false,
      loading: false,
      items: []
    },
    enableCreditNoteWithoutRefund: false,
    batchUnsoldParams: {
      enable_dpv: false,
      invoice_actions: [],
      settlement_actions: []
    },
    showInvoiceExtraOptions: [],
    enablePoliceBook: false,
    appliesTo: [
      {key: i18n.t('Receipt'), value: 'receipt'},
      {key: i18n.t('Inventory'), value: 'inventory'},
      {key: i18n.t('Lot'), value: 'lot'},
    ],
    calculateFrom: [
      {key: i18n.t('Hammer Price'), value: 'hammer_price'},
      {key: i18n.t('Premium'), value: 'premium'},
      {key: i18n.t('Commission'), value: 'commission'},
      {key: i18n.t('Hammer Price (Excluding VAT – France Only)'), value: 'vendor_financial_price'},
    ],
    levels: [
      {key: i18n.t('Branch'), value: 'branch'},
      {key: i18n.t('Customer'), value: 'customer'},
      {key: i18n.t('Receipt'), value: 'receipt'},
      {key: i18n.t('Inventory Item'), value: 'inventory'},
      {key: i18n.t('Lot'), value: 'lot'}
    ],
    yesNo: [
      {key: i18n.t('Yes'), value: 'yes'},
      {key: i18n.t('No'), value: 'no'}
    ],
    correspondenceValues: [
      {key: i18n.t('Email'), value: 'email'},
      {key: i18n.t('Print'), value: 'print'},
    ],
    batchPaymentStatuses: [
      {key: i18n.t('Pending'), value: 'pending'},
      {key: i18n.t('Approved'), value: 'approved'},
    ],
    invoiceTypes: [
      {key: 'auction', text: i18n.t('Auction')},
      {key: 'manual', text: i18n.t('Manual')},
      {key: 'service', text: i18n.t('Service')},
      {key: 'deposit', text: i18n.t('Deposit')},
      {key: 'credit_note', text: i18n.t('Credit Note')}
    ],
    settlementTypes: [
      {value: 'auction', key: i18n.t('Auction')},
      {value: 'manual', key: i18n.t('Manual')},
      {value: 'auction_introductory', key: i18n.t('Auction Introductory')},
      {value: 'manual_introductory', key: i18n.t('Manual Introductory')},
      {value: 'debit_note', key: i18n.t('Debit Note')},
    ],
    checkStatuses: [
      {value: 'active', key: i18n.t('Active')},
      {value: 'cancelled', key: i18n.t('Cancelled')}
    ],
    paymentTypes: [
      {value: 'refund', key: i18n.t('Refund')},
      {value: 'payment', key: i18n.t('Payment')}
    ],
    showSettlementExtraOptions: [],
    artisioTableSelectionModal: {
      show: false,
      items: null,
      columns: null,
      tableIdentifier: null,
    },
    translationProvider: null,
    inventoryQrCodeForWebappURL: null,
    receiptTypes: [],
    contractApiProvider: null,
    isDocusignEnabled: null,
    generalContractModal: getDefaultGeneralContractModal(),
    allowWebappConditionReportRequests: [
      {key: 'Disabled', value: 'disabled'},
      {key: 'Allow for Registered Users Only', value: 'allow_registered'},
      {key: 'Allow for All', value: 'allow_all'},
    ],
    shippingConfigEnabled: null,
    addressModal: {
      show: false,
      object: null,
      customerUuid: null,
      modalReference: null,
    },
    taxStatusClassName: false,
    dynamicTexts: {},
    defaultItemDynamicFieldsTemplate: null,
    itemLocationMoveModal: {
      show: false,
      itemLocationUuid: null,
    },
    identificationDynamicFields: null
  },
  getters: {
    showPricePerUnitField(state) {
      return !!state.lotAmountsCalculationsLogic
    },
    isIntermediaryCustomerTypesEnabled(state) {
      return state.intermediaryCustomerTypes && state.intermediaryCustomerTypes.length > 0
    },
    countryMap(state) {
      return Object.fromEntries(state.countries.map(c => ([c.country_code, c.name])))
    },
    trustLevels(state) {
      if (state.currentBranch.trust_levels) {
        return state.currentBranch.trust_levels.map((trustLevel) => {
          return {
            uuid: trustLevel.uuid,
            name: `${trustLevel.name} - ${Formatter.asCurrency(trustLevel.credit_limit)}`,
            value: trustLevel.uuid,
            exclude_from_auto_assignment: trustLevel.exclude_from_auto_assignment,
            credit_limit: trustLevel.credit_limit
          }
        })
      }
      return []
    },
    formattedUiLanguages(state) {
      const tmpMap = {
        en: "English",
        fr: "French"
      }
      return state.uiLanguages.map(l => {
        return {
          value: l,
          key: tmpMap[l]
        }
      })
    },
    isAvalaraEnabled(state) {
      return state.taxStatusClassName === 'AvalaraTax'
    },
  },
  actions: {
    async initGlobals({commit, dispatch}) {
      commit('setLoaded', false);

      const response = await http.get(AppSettings.getUrl(
        '/api/v1/settings/?expand=branches,branch.currency,branch,permissions,branch.languages,branch.clerks.languages,branch.logo,customer_titles,branch.trust_levels,hide_date'
      ))

      if (!response.success) {
        return false
      }

      let body = response.body

      await commit('updateGeneralSettings', body);
      await commit('updateExcludeSideBarColumns');
      await commit('getPermissionGroups', body.permissions);
      await commit('getCurrentUser', body['active-user']);
      dispatch("getItemLocations");
      await commit('updateCountries', body.countries);
      await commit('updateCurrencies', body.currencies);
      await commit('updateLocales', body.locales);
      await commit('updateIdentificationDynamicFields', body.identification_dynamic_fields)
      EventBus.$emit(LOCALES_LOADED, body.locales);
      await commit('updateTaxStatuses', body['tax-statuses']);
      await commit('setup/branch/getBranches', body.branches, {root: true});
      await commit('setup/department/getDepartments', body.departments, {root: true});
      await commit('handleMenuItems')
      await commit('initPaymentAccountingOptions')
      await dispatch('initTableDataForModules')
      await dispatch('setInventoryToggleColumnsDynamicFields')
      await dispatch('setLiveLotsPerformanceToggleColumnsDynamicFields')
      await dispatch('setAuctionToggleColumnsDynamicFields')
      await dispatch('setReceiptToggleColumnsDynamicFields')
      await dispatch('setIdentificationToggleColumnsDynamicFields')
      await dispatch('updateToggleColumnsForModules')
      await dispatch('setCurrentLanguage')
      commit('setLoaded', true);

      setTimeout(() => {
        dispatch('showImportantNotificationModal')
      }, 700)

      setTimeout(() => {
        dispatch('showReleaseNoteModalStartup')
      }, 700)

      await dispatch('setDynamicTexts')

      return body;
    },
    updateGlobalLoader({commit}, value) {
      commit('setLoaded', value);
    },
    async getItemLocations({state, dispatch}) {
      let queryParams = {expand: "children", level: 0}
      if (state.branchBasedItemLocation) {
        queryParams['branch_uuid'] = state.currentBranch.uuid;
      }
      let response = await ItemLocationService.getItemLocations(queryParams);
      if (response.success) {
        state.itemLocations = response.body;
        state.defaultItemLocation = await dispatch('getDefaultItemLocationFromCurrentBranch')
      }
    },
    async updateToggleColumnsForModules({state}) {
      let visibleTableColumns = state.currentUser.visible_table_columns
      let actions = []

      for (let key in visibleTableColumns) {
        let selectedColumns = visibleTableColumns[key].toggle_columns;
        if (selectedColumns) {

          let moduleName
          let submoduleName
          let tableSource

          let data = key.split('.');
          if (data.length === 1) {
            moduleName = data[0] || '';
          } else if (data.length === 2) {
            moduleName = data[0] || '';
            tableSource = data[1] || '';
          } else if (data.length > 2) {
            moduleName = data[0] || '';
            submoduleName = data[1] || ''
            tableSource = data[2] || '';
          }

          let module = store.state[moduleName]

          if (!module) {
            continue
          }

          if (submoduleName) {
            module = module[submoduleName]
          }

          if (tableSource) {
            module.tableSource = tableSource
          }

          let path = moduleName
          if (submoduleName) {
            path += '/' + submoduleName
          }

          actions.push(store.dispatch(`${path}/updateToggleColumns`, {
            selectedColumns: visibleTableColumns[key].toggle_columns,
            isSaveAction: false
          }));
        }
      }

      await Promise.all(actions)

      return true;
    },
    async initTableDataForModules() {
      const modules = ['bids', 'sales', 'inventory', 'marketing/customer', 'settlements', 'customer', 'invoices', 'bidders', 'vendors']
      let actions = []

      for (let moduleName of modules) {
        actions.push(store.dispatch(`${moduleName}/initTableData`, null, {root: true}));
      }

      await Promise.all(actions)

      return true;
    },
    setInventoryToggleColumnsDynamicFields({state}) {
      const dynamicFieldsModuleNames = ['inventory', 'temporaryItems', 'lots', 'liveLotsPerformance']
      const dynamicFields = state.uniqueDynamicFields

      dynamicFieldsModuleNames.forEach(name => {
        const tables = store.state[name].tableData
        for (let tableName in tables) {
          const currentTable = store.state[name].tableData[tableName].toggleColumns
          for (let field in dynamicFields) {
            const index = currentTable.fields.findIndex(f => f.key === field)
            if (index === -1) {
              currentTable.fields.push({
                key: field,
                label: dynamicFields[field].label,
                sortable: false,
                isVisible: false,
                expand: '',
                type: dynamicFields[field].field_class_name === 'MainField' ? 'text' : dynamicFields[field].type,
                choices: dynamicFields[field].rules.choices || [],
                tdClass: field === 'description' ? 'description-col' : 'dynamic-fields-col'
              })
              currentTable.dynamicFields.push(field)
            }
          }
          store.state[name].tableData[tableName].toggleColumns = {...currentTable}
        }
      })

      return true
    },
    setLiveLotsPerformanceToggleColumnsDynamicFields({state}) {
      const moduleName = 'liveLotsPerformance'
      const dynamicFields = state.uniqueDynamicFields
      const currentTable = store.state[moduleName].toggleColumns
      for (let field in dynamicFields) {
        const index = currentTable.fields.findIndex(f => f.key === field)
        if (index === -1) {
          currentTable.fields.push({
            key: field,
            label: dynamicFields[field].label,
            sortable: false,
            isVisible: false,
            expand: '',
            type: dynamicFields[field].field_class_name === 'MainField' ? 'text' : dynamicFields[field].type,
            choices: dynamicFields[field].rules.choices || [],
            tdClass: field === 'description' ? 'description-col' : 'dynamic-fields-col'
          })
          currentTable.dynamicFields.push(field)
        }
      }
      store.state[moduleName].toggleColumns = {...currentTable}
      return true
    },
    setAuctionToggleColumnsDynamicFields({state}) {
      const dynamicFieldsModuleNames = ['sales']

      if (!state.currentBranch.auction_dynamic_fields_template || Object.keys(state.currentBranch.auction_dynamic_fields_template).length === 0) {
        return
      }

      let uniqueAuctionDynamicFields = []
      for (let auctionType in state.currentBranch.auction_dynamic_fields_template) {
        for (let dfKey in state.currentBranch.auction_dynamic_fields_template[auctionType]) {
          const df = state.currentBranch.auction_dynamic_fields_template[auctionType][dfKey]
          uniqueAuctionDynamicFields.push({...df, key: dfKey})
        }
      }

      dynamicFieldsModuleNames.forEach(name => {
        const tables = store.state[name].tableData
        for (let tableName in tables) {
          const currentTable = store.state[name].tableData[tableName].toggleColumns
          for (let df of uniqueAuctionDynamicFields) {
            const index = currentTable.fields.findIndex(f => f.key === df.key)
            if (index === -1) {
              currentTable.fields.push({
                key: df.key,
                label: df.label,
                sortable: false,
                isVisible: false,
                expand: '',
                type: df.field_class_name === 'MainField' ? 'text' : df.type,
                choices: df.rules.choices || [],
                tdClass: 'dynamic-fields-col'
              })
              currentTable.dynamicFields.push(df.key)
            }
          }
          store.state[name].tableData[tableName].toggleColumns = {...currentTable}
        }
      })

      return true
    },

    setReceiptToggleColumnsDynamicFields({state}) {
      if (!state.currentBranch.receipt_dynamic_fields_template || Object.keys(state.currentBranch.receipt_dynamic_fields_template).length === 0) {
        return;
      }

      let uniqueAuctionDynamicFields = []
      for (let receiptTypeKey in state.currentBranch.receipt_dynamic_fields_template) {
        for (let dfKey in state.currentBranch.receipt_dynamic_fields_template[receiptTypeKey]) {
          const df = state.currentBranch.receipt_dynamic_fields_template[receiptTypeKey][dfKey]
          uniqueAuctionDynamicFields.push({...df, key: dfKey})
        }
      }

      const tableData = store.state['receipts'].tableData;
      for (let tableSource in tableData) {
        const toggleColumns = store.state['receipts'].tableData[tableSource].toggleColumns;
        for (let df of uniqueAuctionDynamicFields) {
          const index = toggleColumns.fields.findIndex(f => f.key === df.key);
          if (index === -1) {
            toggleColumns.fields.push({
              key: df.key,
              label: df.label,
              sortable: false,
              isVisible: false,
              expand: '',
              type: df.field_class_name === 'MainField' ? 'text' : df.type,
              choices: df.rules.choices || [],
              tdClass: 'dynamic-fields-col'
            })
            toggleColumns.dynamicFields.push(df.key);
          }
          store.state['receipts'].tableData[tableSource].toggleColumns = {...toggleColumns};
        }
      }

      return true;
    },

    updateMenuCollapsed: ({state}, payload) => {
      state.menu.collapsed = payload;
    },
    updateCurrentUser: ({state}, payload) => {
      state.currentUser = {...state.currentUser, ...payload}
    },
    addProgress({state}, name) {
      let progress = {
        'name': name,
        'progressValue': 0,
        'uuid': uuid.v4()
      };
      state.progresses.push(progress)
      return progress;
    },
    removeProgress({state}, uuid) {
      state.progresses = state.progresses.filter(obj => obj.uuid !== uuid);
    },
    updateProgressValue({state}, progress) {
      if (state.progresses.length) {
        let progressIndex = state.progresses.findIndex(p => p.uuid === progress.uuid)
        if (progressIndex !== -1) {
          state.progresses[progressIndex].progressValue = progress.progressValue;
          state.progresses[progressIndex].name = progress.name ? progress.name : state.progresses[progressIndex].name;
        }
      }
    },
    createUpdateOrRemoveProgress({state, dispatch}, payload) {
      let progressIndex = state.progresses.findIndex(p => p.uuid === payload.uuid)
      if (progressIndex === -1) {
        dispatch('addProgress', payload)
      } else {
        if (!payload.finished) {
          state.progresses[progressIndex].progressValue = payload.progressValue;
        } else {
          state.progresses = state.progresses.filter(obj => obj.uuid !== payload.uuid);
        }
      }
    },
    setIdentificationToggleColumnsDynamicFields({state}) {
      if (!hasPermission('view_customeridentification')) {
        return;
      }
      const dynamicFieldsModuleNames = ['customer', 'bidders', 'invoices', 'settlements']

      if (!state.identificationDynamicFields || state.identificationDynamicFields.length === 0) {
        return
      }
      const expandMap = {
        'customer': 'identification',
        'bidders': 'customer.identification',
        'invoices': 'customer.identification',
        'settlements': 'customer.identification',
      }
      dynamicFieldsModuleNames.forEach(name => {
        const tables = store.state[name].tableData
        for (let tableName in tables) {
          const currentTable = store.state[name].tableData[tableName].toggleColumns
          for (let df of state.identificationDynamicFields) {
            const index = currentTable.fields.findIndex(f => f.key === df.key)
            if (index === -1) {
              currentTable.fields.push({
                key: df.key,
                label: df.label,
                sortable: false,
                isVisible: false,
                expand: expandMap[name],
                type: df.field_class_name === 'MainField' ? 'text' : df.type,
                choices: df.rules.choices || [],
                tdClass: 'dynamic-fields-col'
              })
              currentTable.dynamicFields.push(df.key)
            }
          }
          store.state[name].tableData[tableName].toggleColumns = {...currentTable}
        }
      })

      return true
    },
    updateWarning({commit}, warning) {
      commit('updateWarning', warning)
    },
    showToggleColumnsModal({commit}, payload) {
      commit('showToggleColumnsModal', payload)
    },
    hideToggleColumnsModal({commit}) {
      commit('hideToggleColumnsModal')
    },
    showDateRangeModal({commit}) {
      commit('showDateRangeModal');
    },
    hideDateRangeModal({commit}) {
      commit('hideDateRangeModal');
    },
    changeGoogleApiSetUp({commit}, payload) {
      commit('changeGoogleApiSetUp', payload)
    },
    async updateUserExtraData({state, dispatch}, {data, tableName}) {
      let params = _.cloneDeep(state.currentUser);

      if (params.visible_table_columns && Object.keys(params.visible_table_columns).length > 0) {
        const savedColumns = params.visible_table_columns;
        params.visible_table_columns = {
          ...savedColumns,
          [tableName]: {
            ...savedColumns[tableName],
            'sort_columns': [`${data.sortDesc ? '-' : ''}${data.sortBy}`]
          }
        };
      } else {
        params.visible_table_columns = {[tableName]: {'sort_columns': [`${data.sortDesc ? '-' : ''}${data.sortBy}`]}};
      }

      const {success, body} = await ProfileService.updateUserData(state.currentUser.uuid, {
        visible_table_columns: params.visible_table_columns,
        email: params.email
      });

      if (success) {
        dispatch('updateCurrentUser', body);
      }
    },
    getTableDataOrdering({state}, {tableData, tableName}) {
      let params = state.currentUser;
      let ordering = tableData.ordering;

      if (params.visible_table_columns && Object.keys(params.visible_table_columns).length > 0) {
        if (params.visible_table_columns[tableName] && params.visible_table_columns[tableName].sort_columns) {
          ordering = params.visible_table_columns[tableName].sort_columns[0];
        }
      }

      return ordering;
    },
    updateLoginAlertMessage({commit}, msg) {
      commit('updateLoginAlertMessage', msg)
    },
    initIdleTracker({state}) {
      if (state.idleTimeoutMilliseconds) {
        let idleTracker = new ArtisioIdleTracker();
        idleTracker.start(state.idleTimeoutMilliseconds);
        state.idleTracker = idleTracker
      }
    },
    logoutCallback({state}) {
      console.log("LOGOUT CALLBACK");
      state.idleTracker = null
    },
    configureContinuousAuctionLotFormDefaultDatesConfiguration({state}, dateModel) {
      if (state.enableContinuousAuction && state.continuousAuctionLotFormDefaultDatesConfiguration) {
        let start_step = state.continuousAuctionLotFormDefaultDatesConfiguration.start_date_step;
        let end_step = state.continuousAuctionLotFormDefaultDatesConfiguration.end_date_step;

        if (start_step || start_step === 0) {
          let date = new Date();
          dateModel.start_date = moment((date.setDate(date.getDate() + start_step))).format(SYSTEM_DATE_FORMAT);
        }

        if (end_step || end_step === 0) {
          let date = new Date();
          dateModel.end_date = moment((date.setDate(date.getDate() + end_step))).format(SYSTEM_DATE_FORMAT);
        }
      }
    },
    getDefaultItemLocationFromCurrentBranch({state}) {
      let finder = (root) => {
        let stack = [], node, ii;
        stack.push(root);

        while (stack.length > 0) {
          node = stack.pop();
          if (node.branch_uuid === state.currentBranch.uuid && node.is_primary) {
            return node;
          } else if (node.children && node.children.length) {
            for (ii = 0; ii < node.children.length; ii += 1) {
              stack.push(node.children[ii]);
            }
          }
        }
        return null;
      }

      for (let item of state.itemLocations) {
        let res = finder(item)
        if (res) {
          return res
        }
      }

      return null;
    },
    updateSocketLastInteractionTime({commit}) {
      commit('updateSocketLastInteractionTime')
    },
    showImportantNotificationModal({state}) {
      if (!state.importantNotificationInfo || !state.importantNotificationInfo.title || !state.importantNotificationInfo.body) {
        return false
      }

      let data = localStorage.getItem(IMPORTANT_INFO_DISMISSED)

      if (data) {
        try {
          data = JSON.parse(data)
          if (data && data.title === state.importantNotificationInfo.title && data.body === state.importantNotificationInfo.body) {
            return false // already dismissed with same title and body
          } else {
            localStorage.removeItem(IMPORTANT_INFO_DISMISSED)
          }
        } catch (e) {
          localStorage.removeItem(IMPORTANT_INFO_DISMISSED)
        }
      }

      state.importantNotificationModal.show = true
    },
    hideImportantNotificationModal({state}) {
      state.importantNotificationModal.show = false
    },
    showReleaseNoteModalStartup({state, commit}) {
      if (!state.releaseNoteInfo || !state.releaseNoteInfo.version || !state.releaseNoteInfo.date) {
        return false
      }

      if (state.releaseNoteInfo.hide_date && new Date() > new Date(state.releaseNoteInfo.hide_date)) {
        return false
      }

      let data = localStorage.getItem(RELEASE_NOTE_DISMISSED)
      if (data) {
        try {
          if (data === state.releaseNoteInfo.uuid) {
            return false // already dismissed with same title and body
          } else {
            localStorage.removeItem(RELEASE_NOTE_DISMISSED)
          }
        } catch (e) {
          localStorage.removeItem(RELEASE_NOTE_DISMISSED)
        }
      }
      commit('showReleaseNoteModal', {doNotShowAgainVisible: true, releaseNote: state.releaseNoteInfo})
    },
    showReleaseNoteModalForce({state, commit}) {
      commit('showReleaseNoteModal', {doNotShowAgainVisible: false, releaseNote: state.releaseNoteInfo})
    },
    showReleaseNoteModalPayload({commit, dispatch}, payload) {
      dispatch('hideReleaseNotesListModal')
      commit('showReleaseNoteModal', payload)
    },
    hideReleaseNoteModal({state}) {
      state.releaseNoteModal.show = false
      state.releaseNoteModal.releaseNote = null
      state.releaseNoteModal.doNotShowAgainVisible = false
    },
    async showReleaseNotesListModal({state, dispatch}) {
      state.releaseNotesListModal.loading = true
      const response = await ReleaseNotesService.getReleaseNotesList()
      if (response.success) {
        state.releaseNotesListModal.items = response.body
        state.releaseNotesListModal.loading = false
        dispatch('hideReleaseNoteModal')
        state.releaseNotesListModal.show = true
      } else {
        state.releaseNotesListModal.loading = false
      }
    },
    hideReleaseNotesListModal({state}) {
      state.releaseNotesListModal.show = false
      state.releaseNotesListModal.loading = false
      state.releaseNotesListModal.items = []
    },
    setCurrentLanguage({state}) {
      if (!state.currentUser.preferred_language) {
        i18nService.setLanguage('en')
        return true
      }

      let currentLang = i18nService.getLanguage()

      if (state.currentUser && state.currentUser.preferred_language && currentLang !== state.currentUser.preferred_language) {
        i18nService.setLanguage(state.currentUser.preferred_language, true)
      }

      return true
    },
    showArtisioTableSelectionModal({state}, {items, columns, tableIdentifier}) {
      state.artisioTableSelectionModal.columns = columns
      state.artisioTableSelectionModal.items = _.cloneDeep(items)
      state.artisioTableSelectionModal.show = true
      state.artisioTableSelectionModal.tableIdentifier = tableIdentifier
    },
    hideArtisioTableSelectionModal({state}) {
      state.artisioTableSelectionModal.show = false
      state.artisioTableSelectionModal.items = null
      state.artisioTableSelectionModal.columns = null
      state.artisioTableSelectionModal.tableIdentifier = null
    },
    showGeneralContractModal({state}, {
      object = null, source, fileType, objectName, enableESignature = false, refreshOnSubmit = false, modalTitle = null
    } = {}) {
      state.generalContractModal.show = true;
      state.generalContractModal.object = object;
      state.generalContractModal.source = source;
      state.generalContractModal.fileType = fileType;
      state.generalContractModal.objectName = objectName;
      state.generalContractModal.enableESignature = enableESignature;
      state.generalContractModal.refreshOnSubmit = refreshOnSubmit;
      state.generalContractModal.modalTitle = modalTitle;
    },
    hideGeneralContractModal({state}) {
      state.generalContractModal = getDefaultGeneralContractModal()
    },
    async getGeneralContractModalData({state}, {object, fileType, objectName, extra_data = {}}) {
      state.generalContractModal.loading = true;
      let response = await ContractService.getContractPdf(object.uuid, objectName, fileType, extra_data)
      state.generalContractModal.loading = false;
      if (response.success) {
        state.generalContractModal.pdf_url = response.body.pdf_url
        state.generalContractModal.status = response.body.contract_data.status
        state.generalContractModal.signature = response.body.contract_data.signature
        state.generalContractModal.staff_signature = response.body.contract_data.staff_signature
        state.generalContractModal.contract_data = response.body.contract_data
      }
      return response;
    },
    showAddressModal({state}, {object, modalReference, customerUuid}) {
      state.addressModal.show = true
      state.addressModal.modalReference = _.cloneDeep(modalReference)
      state.addressModal.customerUuid = customerUuid
      state.addressModal.object = _.cloneDeep(object)
    },
    hideAddressModal({state}) {
      state.addressModal = {
        show: false,
        object: null,
        customerUuid: null,
        modalReference: null,
      }
    },
    setDynamicTexts({state, getters}) {
      state.dynamicTexts = {
        hammerVat: getters.isAvalaraEnabled ? i18n.t('Hammer Tax') : i18n.t('Hammer VAT'),
        premiumVat: getters.isAvalaraEnabled ? i18n.t('Premium Tax') : i18n.t('Premium VAT'),
        inputVat: getters.isAvalaraEnabled ? i18n.t('Sales Tax') : i18n.t('Input VAT'),
        shippingVat: getters.isAvalaraEnabled ? i18n.t('Shipping Tax') : i18n.t('Shipping VAT'),
        vatOnMiscCharges: getters.isAvalaraEnabled ? i18n.t('Misc. Charges Tax') : i18n.t('VAT Misc. Charges'),
        vatOn: getters.isAvalaraEnabled ? i18n.t('Tax on') : i18n.t('VAT on'),
      }

      return true
    },
    async showItemLocationMoveModal({state}, {itemLocationUuid}) {
      state.itemLocationMoveModal.show = true
      state.itemLocationMoveModal.itemLocationUuid = itemLocationUuid
    },
    hideItemLocationMoveModal({state}) {
      state.itemLocationMoveModal.show = false
      state.itemLocationMoveModal.itemLocationUuid = null
    }
  },
  mutations: {
    updateCountries: (state, countries) => {
      state.countries = countries
      state.countries.forEach(c => state.countriesMap[c.country_code] = c)
    },
    getTimedAuctionSettings: (state, settings) => {
      state.timed_auction_settings = settings
    },
    updateCurrencies: (state, currencies) => state.currencies = currencies,
    updateLocales: (state, locales) => {
      state.locales = locales
      state.hasMoreThanOneLanguage = Object.keys(state.locales.available_locales).length > 1
    },
    updateIdentificationDynamicFields: (state, identificationDynamicFields) => {
      if (!identificationDynamicFields) {
        return;
      }
      state.identificationDynamicFields = Object.entries(identificationDynamicFields)
        .map(([key, value]) => ({key, ...value}))
        .sort((a, b) => a.position - b.position);
    },
    setLoaded: (state, param) => state.loaded = param,
    updateTaxStatuses: (state, data) => state.taxStatuses = data,
    getCurrentUser: (state, data) => {
      state.currentUser = data;
      state.currentBranch = data.branch;
    },
    getPermissionGroups: (state, data) => {
      state.permissionGroups = _.sortBy(data, [function (i) {
        return i.permissions.length * (-1)
      }])
    },
    updateGeneralSettings: (state, data) => {
      state.imageFileFormats = data.image_file_formats;
      state.videoFileFormats = data.video_file_formats;
      state.imageMaxFileSize = data.image_max_file_size;
      state.videoMaxFileSize = data.video_max_file_size;
      state.audioFileTypes = data.audio_file_formats;
      state.audioMaxFileSize = data.audio_max_file_size;
      state.auctionImageExportNamingFormat = data.auction_image_export_naming_format;
      state.attachmentFileTypes = data.attachment_file_formats;
      state.attachmentMaxFileSize = data.attachment_max_file_size;
      state.imagesZipMaxFileSize = data.images_zip_max_file_size;
      state.bulkImagesMaxSize = data.bulk_images_max_size;
      state.maxImageCountPerLot = data.max_image_count_per_lot;
      state.imagesZipMaxFileCount = data.images_zip_max_file_count;
      state.bulkImagesMaxFileCount = data.bulk_images_max_file_count;
      state.maxUsesCount = data.max_users_count;
      state.customerMaxAttachmentCount = data.customer_max_attachment_count;
      state.customerMaxAttachmentSizeSum = data.customer_max_attachment_size_sum;
      state.inventoryMaxAttachmentCount = data.inventory_max_attachment_count;
      state.inventoryMaxAttachmentSizeSum = data.inventory_max_attachment_size_sum;
      state.enableInventoryQuantity = data.enable_inventory_quantity;
      state.enableSyncWebsiteFromArtisio = data.enable_sync_website_from_artisio;
      state.enableAccountingExport = data.enable_accounting_export;
      state.lotDelaySecondsOptions = data.lot_delay_seconds_options;
      state.buyNowCutOffDaysOptions = data.buy_now_cut_off_days_options;
      state.biddingExtensionOptions = data.bidding_extension_options;
      state.maxTotalDelayOptions = data.max_total_delay_options;
      state.defaultAuctionType = data.default_auction_type;
      state.auctionSettingsDefaultValues = data.auction_settings_default_values;
      state.settlementLabels = data.settlement_labels;
      state.template_types = data.template_types || [];
      state.notificationActivityTypes = data.notification_activity_types || [];
      // Optional default on each {key, value} option; at most one true per list (see helper.service.getDefaultLifecycleOptionKey).
      state.cataloguingLifecycleOptions = data.cataloguing_lifecycle_options || [];
      state.photographyLifecycleOptions = data.photography_lifecycle_options || [];
      state.miscellaneousItemCharges = [...data.miscellaneous_item_charges, ...state.miscellaneousItemCharges];
      state.invoiceMiscellaneousItemCharges = [...data.invoice_miscellaneous_item_charges, ...[
        {key: 'other', value: i18n.t("Other")}
      ]];
      state.predefinedVendorChargeNames = [...data.predefined_vendor_charge_names, ...[
        {key: 'other', value: i18n.t("Other")}
      ]];
      state.generalRulesAndRestrictions = data.general_rules_and_restrictions;
      state.isCarAuctionHouse = data.is_car_auction_house;
      state.isDynamicFieldsTemplateFromCategory = data.is_dynamic_fields_template_from_category;
      state.defaultBidderStatus = data.default_bidder_status;
      state.liveAuctionProvider = data.live_auction_provider;
      state.liveAuctionProviderName = data.live_auction_provider_name;
      state.isAccountingEnabled = data.is_accounting_enabled;
      state.isManualAccountingSyncDisabled = data.disable_manual_accounting_sync;
      state.accountingProvider = data.accounting_provider;
      state.hasArtisioTimedProvider = !!data.artisio_timed_provider_info;
      state.enableContinuousAuction = data.enable_continuous_auction;
      state.permissionRoles = data.roles;
      state.contractFileTypes = data.contract_file_formats;
      state.customerMaxContractCount = data.customer_max_contract_count;
      state.customerMaxContractSizeSum = data.customer_max_contract_size_sum;
      state.contractMaxFileSize = data.contract_max_file_size;
      state.availableFilterFields = data.available_filter_fields;
      state.uniqueDynamicFields = data.unique_dynamic_fields;
      state.googleMapToken = data.google_map_token;
      state.departmentThumbnailSettings = data.department_thumbnail_settings;
      state.dynamicFieldsFilters = data.dynamic_fields_filters;
      state.identificationFieldsFilters = data.identification_fields_filters;
      state.addressTypeToShowInCustomerEditForm = data.address_type_to_show_in_customer_edit_form;
      state.oldLotPrintoutsEnabled = data.old_lot_printouts_enabled;
      state.postCodeSearchProvider = data.post_code_search_provider;
      state.postCodeProviderInfo = data.post_code_provider_info;
      state.idleTimeoutMilliseconds = data.auto_logout_timeout ? data.auto_logout_timeout * 1000 : null
      state.continuousAuctionLotFormDefaultDatesConfiguration = data.continuous_auction_lot_form_default_dates_configuration
      state.data_collection_provider_info = data.data_collection_provider_info
      state.hasStripeProvider = data.has_stripe_provider
      state.collectionInfoEnabled = data.inventory_form_collection_info_enabled_by_default;
      state.customerDefaultEmailDomain = data.customer_default_email_domain;
      state.isSalesTaxEnabled = data.is_sales_tax_enabled;
      state.branchBasedItemLocation = data.branch_based_item_location;
      state.paymentMethods = data.payment_methods || state.paymentMethods;
      state.paymentMethods.forEach(pm => {
        state.paymentMethodsMap[pm.value] = pm.key
      })
      state.enableGroupedItems = data.enable_grouped_items;
      state.autoPopulateAuctionInReservation = data.auto_populate_auction_in_reservation;
      state.enableInventoryDraft = data.enable_inventory_draft || false;
      state.enableSepa = data.enable_sepa || false;
      state.disableItemEditOnSold = data.disable_item_edit_on_sold || false;
      state.lotAmountsCalculationsLogic = data.lot_amounts_calculations_logic;
      state.customerTypes = data.customer_types;
      state.intermediaryCustomerTypes = data.intermediary_customer_types;
      state.intermediaryAgreementTypes = data.intermediary_agreement_types;
      state.defaultMiscellaneousItemCharges = data.default_miscellaneous_item_charges;
      state.inventoryLotAutoSelectEnable = data.inventory_lot_auto_select_enable;
      state.inclusiveTiersEnabled = data.inclusive_tiers_enabled;
      state.customerTitles = data.customer_titles;
      state.enableSettlementCancellation = data.enable_settlement_cancellation;
      state.enableDebitNoteCreation = data.enable_debit_notes;
      state.enableInvoiceCancellation = data.enable_invoice_cancellation;
      state.enableReceiptStatus = data.enable_receipt_status || false;
      state.receiptStatuses = data.receipt_statuses || [];
      state.inclusiveTaxForFinancialObjects = data.inclusive_tax_for_financial_objects || false;
      state.assignLatestPaddleNumber = data.assign_latest_paddle_number || false;
      state.enableTimedSessions = data.enable_timed_sessions || false;
      state.tagsInputFormat = data.tags_input_format;
      state.tagsInputDropdownValues = data.tags_input_dropdown_values || [];
      state.showDepositShortcutInInvoiceForm = data.show_deposit_shortcut_in_invoice_form || false;
      state.reserveTypes = data.reserve_types || [];
      state.enableNlRelations = data.enable_nl_relations;
      state.customerRelationTypes = (data.customer_relation_types || []).map(rt => {
        return {
          ...rt,
          label: i18n.t(rt.label)
        }
      });
      state.inventoryOverviewPrintsHpiData = data.inventory_overview_prints_hpi_data || false;
      state.identityVerificationAttachmentTypes = data.customer_identification_attachment_types;
      state.identityVerificationMaxFileSize = data.customer_identification_max_file_size;
      state.identityVerificationMaxFileCount = data.customer_identification_max_file_count;
      state.saleSources = data.sale_sources;
      state.importantNotificationInfo = data.important_notification_info
      state.releaseNoteInfo = data.release_note
      state.uiLanguages = data.ui_languages || ['en']
      state.enableCreditNoteWithoutRefund = data.enable_credit_note_without_refund;
      state.batchUnsoldParams = data.batch_unsold_params;
      state.showInvoiceExtraOptions = data.show_invoice_extra_options || [];
      state.paymentBankAccounts = data.payment_bank_accounts || [];
      state.enablePoliceBook = data.enable_police_book || false;
      state.showSettlementExtraOptions = data.show_settlement_extra_options || [];
      state.vendorBuyerGroupAccountsEnabled = data.vendor_buyer_group_accounts ? data.vendor_buyer_group_accounts.enable : false;
      state.inventoryQrCodeForWebappURL = data.inventory_qr_code_for_webapp_url;
      state.shippingConfigEnabled = data.shipping_config_enabled || false;
      state.translationProvider = data.translation_provider;
      state.receiptTypes = data.receipt_types || [];
      state.contractApiProvider = data.contract_api_provider;
      state.isDocusignEnabled = data.contract_api_provider === 'DocuSign';
      state.inheritDynamicFieldsValues = data.inherit_dynamic_fields_values;
      state.receiptContainerOptions = data.receipt_container_options.map(i => ({value: i}));
      state.taxStatusClassName = data.tax_status_class_name;
      state.defaultItemDynamicFieldsTemplate = data.default_item_dynamic_fields_template;
      state.clientTierOptions = data.client_tier_options;
      state.artisioTimedProviderInfo = data.artisio_timed_provider_info;
    },
    updateWarning: (state, warning) => state.warning = warning,
    handleMenuItems: (state) => {
      // Following logic is temporary, need to implement recursive deletion logic in menu service
      if (!state.isAccountingEnabled) {
        let setupMenuItem = MenuService.menuItems[MenuService.menuItems.findIndex(i => i.path === '/setup')];
        setupMenuItem.children = [...setupMenuItem.children.filter(i => i.path !== '/accounting')];
      }
      if (!state.isSalesTaxEnabled) {
        let setupMenuItem = MenuService.menuItems[MenuService.menuItems.findIndex(i => i.path === '/setup')];
        setupMenuItem.children = [...setupMenuItem.children.filter(i => i.path !== '/sales-tax-configuration')];
      }
      return true
    },
    updateExcludeSideBarColumns: (state) => {
      if (state.enableContinuousAuction) {
        state.excludeSideBarColumns.push('/sales')
      } else {
        state.excludeSideBarColumns.push('/auctions')
      }
      if (!state.enablePoliceBook) {
        state.excludeSideBarColumns.push('/police_book')
      }
    },
    showToggleColumnsModal: (state, {uuid, fields}) => {
      state.toggleColumns.modal.show = true
      state.toggleColumns.modal.data = fields
      state.toggleColumns.modal.uuid = uuid
    },
    hideToggleColumnsModal: (state) => {
      state.toggleColumns.modal.show = false
      state.toggleColumns.modal.data = []
      state.toggleColumns.modal.uuid = null
    },
    showDateRangeModal: state => {
      state.dateRangeModal.show = true;
    },
    hideDateRangeModal: state => {
      state.dateRangeModal.show = false;
    },
    changeGoogleApiSetUp: (state, payload) => {
      state.isGoogleApiSetUp = payload;
    },
    mutateTimeDiff(state, server_time) {
      if (server_time) {
        state.timeDiff = moment.duration(moment(new Date()).diff(server_time));
      }
    },
    updateLoginAlertMessage: (state, msg) => state.loginAlertMsg = msg,
    initPaymentAccountingOptions: (state) => {
      for (let item of state.paymentMethods) {
        if (item.accounting_code) {
          state.paymentAccountingCodeOptions.push({
            key: `${item.key} - ${item.accounting_code}`,
            value: item.accounting_code
          })
        }
      }
    },
    updateSocketLastInteractionTime: (state) => {
      state.socketLastInteractionTime = new Date().getTime();
    },
    showReleaseNoteModal: (state, payload) => {
      state.releaseNoteModal.show = true
      state.releaseNoteModal.releaseNote = payload.releaseNote
      state.releaseNoteModal.doNotShowAgainVisible = payload.doNotShowAgainVisible
    }
  }
}
